"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCompaniesListPage = exports.CustomerCompanyDetailPageActions = exports.CustomerCompanyDetailPage = void 0;
var customerCompanyDetailPage_1 = require("./customerCompanyDetailPage");
exports.CustomerCompanyDetailPage = customerCompanyDetailPage_1.default;
var customerCompanyDetailPageActions_1 = require("./customerCompanyDetailPageActions");
exports.CustomerCompanyDetailPageActions = customerCompanyDetailPageActions_1.default;
var customerCompaniesListPage_1 = require("./customerCompaniesListPage");
exports.CustomerCompaniesListPage = customerCompaniesListPage_1.default;
